import { render } from "./PlacementType.vue?vue&type=template&id=d66adc58"
import script from "./PlacementType.vue?vue&type=script&lang=js"
export * from "./PlacementType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__